import React from 'react';
import './footer.css';

function Footer() {
    return (
        <div>
            <footer className="footer">
                <p><a href="https://twitter.com/flat8migi" target="_blank">作成者：@flat8migi</a></p>
                <p><a href="https://migi.me/policy/" target="_blank">本ツールを使用する上での注意点、免責事項など</a></p>
            </footer>
        </div>
    );
}

export default Footer;
